module.exports = new __parcel__URL__("bird_logo.4a767494.png").toString();